// Соцсети Lomora — единый источник для приложения (зеркалит landing/lib/links.ts).
// Если ссылка меняется — правим здесь и в лендинге.
export const socials = {
  telegram: 'https://t.me/lomora_chat',
  vk: 'https://vk.com/club239243743',
  dzen: 'https://dzen.ru/lomora',
} as const;

export type SocialNetwork = keyof typeof socials;

/** Цвета глифов соцсетей (TelegramIcon / VkIcon / DzenIcon из shared/ui). */
export const socialColors: Record<SocialNetwork, string> = {
  telegram: '#2AABEE',
  vk: '#0077FF',
  dzen: '#F5F1EC',
};
